import { ArrowCircleLeft } from '@phosphor-icons/react';

export default ArrowCircleLeft;